// Module
var code = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>widget</title><path d=M904,904H120V120H474V0H0V951.37A72.35,72.35,0,0,0,72.3,1024H1024V550H904V904Z /><path d=M951.7,0H614V120H818.19L520,418l85,84.74,299-299V410h120V72.63A72.35,72.35,0,0,0,951.7,0Z /></svg>";
// Exports
module.exports = code;